<template>
    <div class="content">
        <h2>卫生监督意见书</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <!--<el-col :span="24">
                    <el-form-item label="编号:" prop="bh">
                        <el-input style="width:200px; margin-right:10px;"
                        v-model="form.bh"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getWh">获取编号</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="改正情况:" prop="gzqk">
                        <el-radio-group v-model="form.gzqk" @change="getQzqk">
                            <el-radio label=0 :aria-hidden="false">立即改正</el-radio>
                            <el-radio label=1 :aria-hidden="false">天数</el-radio>
                        </el-radio-group>
                        <el-input type="number" v-if="form.gzqk == 1"
                        v-model="form.zgDay"
                        placeholder=""
                        clearable
                        size="small" style="width:140px;" @input="getZgday"
                        />日内整改完毕
                    </el-form-item>
                </el-col>-->
                <el-col :span="24" style="text-align:right;margin-bottom:10px;">
                    <el-button type="primary" size="small" @click="getTuili">推理</el-button>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="监督意见:" prop="jdyj">
                        <el-input type="textarea" rows="7" v-loading="loadingTl"
                        v-model="form.jdyj"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getNr()">选择模板</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit('form')">生成卫生监督意见书</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <!--<el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>-->
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog title="监督意见" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
            <jdyj :wfss="this.wfss" :jdnr="this.jdnr" @handleBackJdyj="handleBackJdyj" @jdyjTk="closeJdyj"  />
        </el-dialog>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="卫生监督意见书" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import jdyj from './jdyj.vue'
export default {
    name: "Layout",
    props:['code','mid','pcId','text','anyou','cfyj','jdyjs','jdyjsList','xcblList','xcjczjTags'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            jcjg:'',
            jdnr:'',
            form:{
                jdyjs_lsh:'',
                bh:'',
                jdyj:'',
                blzt:2,
                qmfs:1,


            },
            rules:{
                bh:[
                    { required: true, message: '现场笔录编号不能为空', trigger: 'blur' }
                ],
                xwrq:[
                    { required: true, message: '询问日期不能为空', trigger: ['change','blur'] }
                ],
                startTime:[
                    { required: true, message: '开始时间不能为空', trigger: ['change','blur'] }
                ],
                endTime:[
                    { required: true, message: '结束时间不能为空', trigger: ['change','blur'] }
                ],
                blzt:[
                    { required: true, message: '笔录状态不能为空', trigger: ['change','blur'] }
                ],
                jdyj:[
                    { required: true, message: '检查内容不能为空', trigger: 'blur' }
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ],
       
            },
            open:false,
            wfss:'',
            wsUrl:'',
            isWs:false,

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[],
            baseUrl:'',
            loadingTl:false,
            qianyan:''
        }
    },
    components: {
        jdyj
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {

        console.log(this.jdyjsList,141)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl
        console.log(this.wfss)
        this.getList()
    },
    methods: {
        getTuili(){
            this.loadingTl = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/otherInferences`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    mid:this.mid,
                    lsh:this.pcId,
                    templateName:this.code
                }
            })
            .then(response => {
                console.log(response.data,1081);
                if(response.data.code == 0 && response.data.data){
                    let str = response.data.data.answer || '';
         
                    str = this.qianyan + str
                    this.$set(this.form,'jdyj',str)
                }else{
                    this.$message.error(response.data.msg);
                }
                this.loadingTl = false
            })
            .catch(error => {
                this.loadingTl = false
                this.$message.error('推理失败！'|| error);
                console.error('There was an error!', error);
            });
        },
        getList(){
 
 
            this.isWs = false 
            console.log(this.jdyjsList,this.jdyjs,158)
            if(this.jdyjsList){
                this.$set(this.form,'jdyjs_lsh',this.jdyjsList.jdyjs_lsh)
                this.$set(this.form,'bh',this.jdyjsList.bianhao)
                this.$set(this.form,'jdyj',this.jdyjsList.jdyj)
                this.isWs = true
                this.wsUrl = this.jdyjsList.url
            }else{
                if(this.jdyjs){
                    this.$set(this.form,'jdyj',this.jdyjs)
                }else{
                    let tet = ''//'针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'
                    this.$set(this.form,'jdyj',tet)
                }

                if(this.xcblList && this.xcblList.length>0){
                    let str = this.xcblList[0].inspectionContentTop
                    this.qianyan = str.replace('检查情况记录如下','提出如下监督意见')+'\n'
                    this.$set(this.form,'jdyj',this.qianyan)
                }
            }     
        },
        getQzqk(){
            console.log(this.form.qzqk)
            if(this.form.gzqk=='0'){
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位立即改正。'
                this.$set(this.form,'jdyj',tet)
            }else{
                if(this.form.zgDay){
                    let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'+this.form.zgDay+'日内整改完毕。'
                    this.$set(this.form,'jdyj',tet)
                }else{
                    let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位XX日内整改完毕。'
                    this.$set(this.form,'jdyj',tet)
                }
            }
        },
        getZgday(){
            console.log(this.form.zgDay)
            if(this.form.zgDay){
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'+this.form.zgDay+'日内整改完毕。'
                this.$set(this.form,'jdyj',tet)
            }else{
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位XX日内整改完毕。'
                this.$set(this.form,'jdyj',tet)
            }
        },
        submit(form){
            if(this.form.gzqk=='1' && !this.form.zgDay){
                this.$message.error('请填写整改天数！')
                return
            }

            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    
                    axios({
                        method: 'post',
                        url: this.baseUrl+`/xx/makeWenshu`,
                        data:{
                            lsh: this.pcId,
                            wsName:'监督意见书',
                            jdyjsLsh:this.form.jdyjs_lsh,
                            xcblBh:this.form.bh,
                            inspectionContent:this.jdyjs,
                            signatureMethod:this.form.jdyj,                                                      
                            cmid:this.cmid,
                            xm:this.xm,
                            dm:this.dm,
                            shi:this.shi,
                            xianqu:this.xianqu,
                            jcjg:this.jcjg
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        console.log(res,809)
                        this.loading = false
                        if(res.data.code == 0 && res.data.data){
                            this.isWs = true
                            this.wsUrl = res.data.data.url
                            this.$set(this.form,'jdyjs_lsh',res.data.data.lsh)                      
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.show()
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        async getWh(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblBh&id=${this.pcId}`)
            console.log(data)
            if(data.data){
                if(data.data.errMessage){
                    this.$set(this.form,'bh',data.data.errMessage)
                }else{
                    let bh = new Date().getFullYear() + '-'
                    this.$set(this.form,'bh',bh)
                }
            }
        },
        async getNr(){
            this.open = true
            this.jdnr = ''//'针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'
        },
        cancel(){
            this.form = {}
            this.open = false
        },
        handleBackJdyj(data){
            this.form.jdyj = this.form.jdyj+data
            this.open = false
        },
        closeJdyj(data){
            this.open = false
        },
        show(){
            if(this.wsUrl){
                let url = this.$router.resolve({
                    path:'/pdf2',
                    query:{
                        wsname:'weishengjianduyijianshu',
                        ws:encodeURIComponent(this.wsUrl) // 手动 encode 一次
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'weishengjianduyijianshu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}
.content >>> .el-loading-spinner{top: 40px !important;}
</style>